// extracted by mini-css-extract-plugin
module.exports = {"panel":"Script_panel__1J4wv","print":"Script_print__1iJfr"};